<div *ngIf="!hideDistributionGraph">
	<div class="lift-histogram-area">
		<div class="ml-8">
			<b>Lift Distribution</b>
		</div>
		<div class="ml-8">
			<b>Postal Codes:</b> <span *ngIf="liftObj?.regions"> {{ liftObj?.regions.length }}</span>
		</div>
		<div class="ml-8">
			<b>Lift Range:</b> <span *ngIf="liftObj?.lift"> {{ liftObj?.lift }}</span>
		</div>
		<div class="graph-area">
			<div id="lift-histogram"></div>
		</div>
	</div>
</div>
